import { request } from './http.js'

/** 获取滚动回测结果；tag 缺省时后端返回默认配置 */
export async function fetchRollingBacktest(tag = '') {
  const qs = tag ? `?tag=${encodeURIComponent(tag)}` : ''
  return request(`/api/backtest/rolling${qs}`)
}
